var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGamesTab2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8096_38)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.63889 13.75L12.3611 13.75C13.1282 13.75 13.75 13.1282 13.75 12.3611L13.75 2.63889C13.75 1.87183 13.1282 1.25 12.3611 1.25L2.63889 1.25C1.87183 1.25 1.25 1.87183 1.25 2.63889L1.25 12.3611C1.25 13.1282 1.87183 13.75 2.63889 13.75Z",
    stroke: "#091DC9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6569 6.25L17.7659 6.60515C17.9448 6.663 18.1105 6.75575 18.2533 6.87801C18.3961 7.00028 18.5132 7.14963 18.5979 7.31743C18.6825 7.48523 18.733 7.66814 18.7464 7.85556C18.7598 8.04298 18.7358 8.2312 18.6759 8.40931L15.5762 17.771C15.4591 18.1288 15.2046 18.4255 14.8687 18.596C14.5328 18.7664 14.1429 18.7967 13.7847 18.6802L7.5 16.6204",
    stroke: "#091DC9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.25 10H13.75",
    stroke: "#091DC9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8096_38"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGamesTab2);
export default __webpack_public_path__ + "static/media/games-tab2.76a382db6704df7b37aedbb135d89a0b.svg";
export { ForwardRef as ReactComponent };